module.exports = __webpack_public_path__ + "static/media/logo_01.16c407cb.jpg";